import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ClinicMembership } from '../../core/models/clinic-membership.model';

export interface PortalNavigationItem {
  label: string;
  icon: string;
  route: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-portal-navigation',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, CommonModule],
  templateUrl: './portal-navigation.html',
  styleUrl: './portal-navigation.scss',
})
export class PortalNavigation {
  @Input({ required: true }) portalName = '';
  @Input() portalIcon = 'bi-heart-pulse-fill';
  @Input() portalClass = 'text-primary';
  @Input() collapseId = 'portalMenu';
  @Input() firstName = '';
  @Input() lastName = '';
  @Input() primaryItems: PortalNavigationItem[] = [];
  @Input() profileRoute = '/dashboard/profile';
  @Input() settingsRoute = '/dashboard/settings';
  @Input() additionalItems: PortalNavigationItem[] = [];

  /** When false, hides the Settings link in the profile dropdown. */
  @Input() showSettings = true;

  /** List of clinics the doctor belongs to (for Switch Clinic). Empty for non-doctors. */
  @Input() clinicMemberships: ClinicMembership[] = [];

  /** When false, hides the role-switch dropdown items (pure managers). */
  @Input() showRoleSwitcher = true;

  /** Emits the clinicId that the user wants to switch to. */
  @Output() switchClinic = new EventEmitter<string>();

  constructor(private router: Router) {}

  navigate(route: string): void {
    this.router.navigateByUrl(route);
  }

  onSwitchClinic(clinicId: string): void {
    this.switchClinic.emit(clinicId);
  }

  logout(): void {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigateByUrl('/login');
  }

  get hasMultipleClinics(): boolean {
    return this.clinicMemberships.length > 1;
  }

  get activeClinicId(): string | null {
    if (typeof localStorage === 'undefined') return null;
    return localStorage.getItem('activeClinicId') || localStorage.getItem('clinicId');
  }

  get activeClinicName(): string {
    const activeClinicId = this.activeClinicId;
    const active = this.clinicMemberships.find(
      (c) => c.currentlyActive || (activeClinicId && c.clinicId === activeClinicId),
    );
    return active ? active.clinicName : '';
  }
}
